// "FAILED_DELIVERY" -> "Failed Delivery" for order statuses shown on the Analytics page.
const ACRONYMS = { awb: 'AWB', rto: 'RTO', ndr: 'NDR', npr: 'NPR', ofd: 'OFD', cod: 'COD', rvp: 'RVP', qc: 'QC' };
/** "AWB_REGISTERED" -> "AWB registered" (sentence case, acronyms kept). */
export const prettyStatus = (s) => {
    if (!s) return '';
    const words = s.toLowerCase().split('_').map((w) => ACRONYMS[w] || w);
    words[0] = ACRONYMS[s.toLowerCase().split('_')[0]] || words[0].charAt(0).toUpperCase() + words[0].slice(1);
    return words.join(' ');
};

/** Minutes -> "2d 4h", "3h 20m", "45m"; "-" when there's no figure. Calendar time. */
export const formatMinutes = (m) => {
    if (m == null || Number.isNaN(m)) return '-';
    const total = Math.round(m);
    if (total < 1) return '< 1m';
    const d = Math.floor(total / 1440);
    const h = Math.floor((total % 1440) / 60);
    const min = total % 60;
    if (d > 0) return h ? `${d}d ${h}h` : `${d}d`;
    if (h > 0) return min ? `${h}h ${min}m` : `${h}h`;
    return `${min}m`;
};

/** 87.5 -> "87.5%"; "-" when there's nothing to measure. */
export const formatPct = (p) => (p == null ? '-' : `${p}%`);
